import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import axios from "axios";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import { Events } from "@/events/events";
import QuestionAnswerImageUploader from "@/components/questions/QuestionAnswerImageUploader.vue";
let AnswerImageUploaderLegacyWrapper = class AnswerImageUploaderLegacyWrapper extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "responseId", void 0);
    _defineProperty(this, "questionId", void 0);
    _defineProperty(this, "imageName", void 0);
    _defineProperty(this, "imagePath", void 0);
    _defineProperty(this, "smallImagePath", void 0);
  }
  get responseImage() {
    if (this.imageName) {
      return {
        imageName: this.imageName,
        imagePath: this.imagePath,
        smallImagePath: this.smallImagePath
      };
    }
    return null;
  }
  onImageUploaded($event) {
    this.saveResponseImage($event);
  }
  onImageDelete() {
    this.deleteResponseImage();
  }
  saveResponseImage(image) {
    axios.put(`/api/v2/quiz-questions-responses/${this.responseId}/image`, {
      imageName: image.originalName,
      imagePath: image.path
    }).then(() => {
      WElMessage.showSuccessMessage(this.$t('chapter.question.answerModification.success'));
      trig(Events.RAFRAICHIR_QUIZZ_QUESTION, this.questionId);
    }).catch(() => WElMessage.showErrorMessage(this.$t('errors.default')));
  }
  deleteResponseImage() {
    axios.delete(`/api/v2/quiz-questions-responses/${this.responseId}/image`).then(() => {
      WElMessage.showSuccessMessage(this.$t('chapter.question.answerModification.success'));
      trig(Events.RAFRAICHIR_QUIZZ_QUESTION, this.questionId);
    }).catch(() => WElMessage.showErrorMessage(this.$t('errors.default')));
  }
};
__decorate([Prop({
  required: true
})], AnswerImageUploaderLegacyWrapper.prototype, "responseId", void 0);
__decorate([Prop({
  required: true
})], AnswerImageUploaderLegacyWrapper.prototype, "questionId", void 0);
__decorate([Prop({
  default: null
})], AnswerImageUploaderLegacyWrapper.prototype, "imageName", void 0);
__decorate([Prop({
  default: null
})], AnswerImageUploaderLegacyWrapper.prototype, "imagePath", void 0);
__decorate([Prop({
  default: null
})], AnswerImageUploaderLegacyWrapper.prototype, "smallImagePath", void 0);
AnswerImageUploaderLegacyWrapper = __decorate([Component({
  components: {
    QuestionAnswerImageUploader
  }
})], AnswerImageUploaderLegacyWrapper);
export default AnswerImageUploaderLegacyWrapper;